window.Products.Book.SpiralNotebook = function() {};
window.Products.Book.SpiralNotebook.inherits(window.Products.Book.Book);
window.Products.Book.SpiralNotebook.id = 71;
window.Products.Book.SpiralNotebook.slug = 'spiral-notebook';
window.Products.Book.SpiralNotebook.has_3d = true;
window.Products.Book.SpiralNotebook.use_variants = true;
window.Products.Book.SpiralNotebook.fit_template_all = true;
window.Products.Book.SpiralNotebook.dpi = 300;

window.Products.Book.SpiralNotebook.prototype.set3dProperties = function(modelViewer) {
	modelViewer.scene.children[0].intensity = 0.96;
	modelViewer.scene.children[1].intensity = 0.12;
	modelViewer.object.position.y = 0.03;
	modelViewer.camera.position.z = 8;
	modelViewer.object.children[0].material[0].side = 2;
	modelViewer.object.children[0].material[3].bumpScale = 0.025;
	modelViewer.object.children[0].material[4].bumpScale = 0.025;
	mRotation = new THREE.Matrix4();
	mRotation.makeRotationAxis(new THREE.Vector3(0, 1, 0).normalize(), 0 * Math.PI / 180);
	mRotation.multiply(modelViewer.object.matrix);
	modelViewer.object.matrix = mRotation;
	modelViewer.object.rotation.setFromRotationMatrix(modelViewer.object.matrix);
	this.updateThreeTexture(modelViewer);
};

window.Products.Book.SpiralNotebook.prototype.displayCover = function(cover, modelViewer) {
	modelViewer.object.children[0].material[0].opacity = cover ? 0.4 : 0;
};

window.Products.Book.SpiralNotebook.prototype.setThreeControls = function(controls) {
	controls.minDistance = 1.5;
	controls.maxDistance = 2;
};

window.Products.Book.SpiralNotebook.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[0].material[1].map = modelViewer.texture;
};

window.Products.Book.SpiralNotebook.prototype.getPageFitDimensions = function(variant, scene){
	// Breaking the code if we're here from landscape cause it just shouldn't happen
	if(variant !== 'portrait') return false;

	var data = this.static.preview_data.scenes[scene].variants[variant];
	var width = 0, height = 0;
	width = data.deltax[1] + data.originalWidth - data.deltax[0];
	height = data.originalHeight;
	return [width, height];
};